module.exports = __webpack_public_path__ + "img/doge.bfe942ea.svg";